import script from "./KakaoMap.vue?vue&type=script&setup=true&lang=js"
export * from "./KakaoMap.vue?vue&type=script&setup=true&lang=js"

import "./KakaoMap.vue?vue&type=style&index=0&id=022eefc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-022eefc6"]])

export default __exports__